// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"82184a52","780":"57d52f07","932":"01d29596"}[chunkId] + ".chunk.css";
};